import {createMuiTheme} from '@material-ui/core/styles';

// import grey from '@material-ui/core/colors/grey';
import lightBlue from '@material-ui/core/colors/lightBlue';

const theme = createMuiTheme({
    palette: {
        primary: {
            light: lightBlue['A100'],
            main: lightBlue['500'],
            dark: lightBlue['A700'],
            contrastText: '#000'
        },
        secondary: {
            light: '#bdbdbd',
            main: '#efefef',
            dark: '#8d8d8d',
            contrastText: '#000'
        }
    },


     // overrides: {
     //     MuiButton: {
     //         root: {
     //             color: 'white',
     //             '&:hover': {
     //                 backgroundColor: '#997aeb'
     //             },
     //             '&:focus': {
     //                 backgroundColor: '#470083',
     //                 color: '#997aeb'
     //             }
     //         }
     //     }
     // }
});

export default theme;



// WEBPACK FOOTER //
// ./src/Styling/theme.js